import { OrderApi } from '@ps/api/order';
import type {
  CreateOrderDtoV3PaymentTypeEnum,
  MeetingDurationEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

export async function bookMeetingSlot(params: {
  storeId: string;
  meetingTypeId: string;
  startTime: string;
  duration: number;
  timezone: string;
}): Promise<void> {
  const orderApi = withClientAPI(OrderApi);

  await orderApi.orderApiControllerCreateOrderInMultiCurrency({
    CreateOrderDtoV3: {
      sellerId: params.storeId,
      quantity: 1,
      paymentType: 'empty' as CreateOrderDtoV3PaymentTypeEnum,
      buyerName: 'PopStore Buyer',
      requestTrackingID: crypto.randomUUID(),
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      returnUrl: window.location.href,
      meeting: {
        startTime: params.startTime,
        duration: params.duration as MeetingDurationEnumItem,
        timezone: params.timezone,
        meetingTypeId: params.meetingTypeId,
      },
    },
  });
}
